import { keymirror } from 'utils/keymirror'

export const BOOKING_FILTERS = keymirror({
  pickupDates: null,
  deliveryDates: null,
  pickupLocation: null,
  deliveryLocation: null,
  pickupRegion: null,
  deliveryRegion: null,
  query: null,
  radius: null,
  stateOptions: null,
  equipment: null,
  podIds: null,
  myLoads: null,
  company: null,
  checkboxFilters: null,
  refresh: null,
  sameDay: null,
  range: null,
  status: null,
  pickupDateRange: null,
  deliveryDateRange: null,
  hasHot: null,
  noAppointmentTime: null,
  unconfirmedAppointment: null,
  hasOptions: null,
  hasRolled: null,
  hasClaims: null,
  multiDay: null,
  afterHours: null,
  dropTrailer: null,
  backhaulEligible: null,
  needsTracking: null,
  shipperRateType: null,
  myIssues: null,
  issueState: null,
  pricingType: null,
  brokerPodKey: null,
})

export const QUICK_FILTERS_COUNT = keymirror({
  numPickups: null,
  numDeliveries: null,
  numPricedUnderContract: null,
  numHot: null,
  numNoOptions: null,
  numWaterfall: null,
  numCovered: null,
  numOffered: null,
  numSameDay: null,
  numNoAppt: null,
  numUnconfirmedAppt: null,
  numNeedsTracking: null,
})
